// @ts-strict-ignore
import { ConditionServiceType, InstallmentConditionType } from '../model/types/PaymentSchema'

export const conditionAdapter = (
	installment: InstallmentConditionType[]
): {
	installmentCode: string
	logicType: string
	productId: number
	name: string
	description: string
	type: string
	productList: ConditionServiceType[]
	installmentValue: number
}[] =>
	installment.map(({ DESCRIPTION, NAME, PRODUCTS, INSTALLMENT_CODE, PRODUCT_ID, LOGIC_TYPE, TYPE }) => ({
		description: DESCRIPTION,
		name: NAME,
		productList: PRODUCTS,
		installmentValue: +INSTALLMENT_CODE.split(`-`)[2],
		installmentCode: INSTALLMENT_CODE,
		productId: PRODUCT_ID,
		logicType: LOGIC_TYPE,
		type: TYPE
	}))
